import Modal from './modal';

class ModalDefault {
	constructor(el) {
		this.el = el;
		this.modalContent = this.el.querySelector('.js__modal--default-content').innerHTML;
		this.initializeModals();
	}

	initializeModals = () => {
		this.el.addEventListener('click', (event) => {
			// A real link inside the trigger (for example a team member's LinkedIn
			// icon) should follow its link, not open the pop-up as well.
			if (event.target.closest('a[href]')) {
				return;
			}

			Modal.show(
				this.modalContent
			);
		});
	};

}

export default ModalDefault;